import Skeleton from "react-loading-skeleton";

import styles from "./styles.module.scss";

export function AppointmentCardSkeleton() {
  return (
    <div className={styles.container}>
      <div className={styles.firstRow}>
        <div className={styles.profileContainer}>
          <div className={styles.avatarContainer}>
            <Skeleton circle width={"3.75rem"} height={"3.75rem"} />
            <Skeleton width={"3.75rem"} height={"0.6rem"} />
          </div>
          <div>
            <Skeleton width={"5rem"} />
            <Skeleton width={"9rem"} />
            <Skeleton width={"7rem"} />
          </div>
        </div>
        <div className={styles.profileContainer}>
          <div className={styles.avatarContainer}>
            <Skeleton circle width={"3.75rem"} height={"3.75rem"} />
            <Skeleton width={"3.75rem"} height={"0.6rem"} />
          </div>
          <div>
            <Skeleton width={"5rem"} />
            <Skeleton width={"9rem"} />
            <Skeleton width={"7rem"} />
          </div>
        </div>
        <div>
          <Skeleton width={"5rem"} />
          <Skeleton width={"9rem"} />
          <Skeleton width={"7rem"} />
        </div>
      </div>
      <div className={styles.secondRow}>
        <div className={styles.statusContainer}>
          <Skeleton count={8} width={"4rem"} height={"1.25rem"} />
        </div>
        <Skeleton width={"5rem"} height={"2.25rem"} />
      </div>
      <div className={styles.actions}>
        <Skeleton count={3} width={"1rem"} height={"1rem"} />
      </div>
    </div>
  );
}
